import React from "react";

import {
  styled,
  Typography,
  Card,
  CardActions,
  CardContent,
  Collapse,
  ButtonBase,
  Stack,
} from "@mui/material";
import { ChevronLeft } from "mdi-material-ui";

const shouldForwardProp = (prop) => prop !== "expanded";
const ExpandIcon = styled(ChevronLeft, { shouldForwardProp })(
  ({ expanded, theme }) => ({
    transition: theme.transitions.create("transform") + "!important",
    transform: `rotate(${expanded ? -90 : 0}deg)`,
  })
);

export default function StatsCard({ title, children }) {
  const [open, setOpen] = React.useState(false);
  const toggle = React.useCallback(() => {
    setOpen((o) => !o);
  }, []);

  return (
    <Card>
      <ButtonBase
        onClick={toggle}
        component={CardActions}
        sx={{ display: "block", p: (t) => t.spacing(1, 2) }}
      >
        <Stack spacing={2} direction="row" alignItems="center">
          <Typography variant="h3" color="primary" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>

          <ExpandIcon expanded={open} />
        </Stack>
      </ButtonBase>

      <Collapse in={open} unmountOnExit>
        <CardContent>{children}</CardContent>
      </Collapse>
    </Card>
  );
}
